import BiddingHistory from '@components/BiddingHistory/BiddingHistory'

const BidHistory = ({
  bidHistory = [],
  options = {},
  closeBidHistory,
  visible = true,
}: any) => {
  if (!visible) return <></>

  const {
    isListView = true,
    isBidsPage = true,
    isWatchlistPage = true,
    cardIndex = 0,
    twss = null,
  } = options

  const checkIsRightCard = () => {
    if (!isBidsPage && !isWatchlistPage) {
      if (cardIndex === 1 || (cardIndex > 3 && cardIndex % 2 === 0)) {
        return true
      }
    } else {
      if (cardIndex % 2 === 1) {
        return true
      }
    }
    return false
  }

  const getBidHistoryCss = () => {
    const isRightCard = checkIsRightCard()

    if (isListView)
      return 'top-1/2 transform -translate-y-1/2 xl:left-1/2 2xl:left-1/3'
    if (isRightCard)
      return 'top-1/2 transform -translate-y-1/2 -left-full md:left-2.5'
    return 'top-1/2 transform -translate-y-1/2 left-2.5'
  }

  return (
    <BiddingHistory
      bidHistory={bidHistory}
      setShowBidHistory={closeBidHistory}
      twcss={twss === null ? getBidHistoryCss() : twss}
    />
  )
}

export default BidHistory
